import { render } from "./elem-label.vue?vue&type=template&id=3cb2b525&ts=true"
import script from "./elem-label.vue?vue&type=script&lang=ts"
export * from "./elem-label.vue?vue&type=script&lang=ts"

import "./elem-label.vue?vue&type=style&index=0&id=3cb2b525&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__